import { Controller, useFormContext } from "react-hook-form";
import { ReQuotationBoFormData } from "./expeditionsUpdateBoForm";
import { ReCustomQuotationFormData } from "@/components/backOffice/pendingCustomQuotation/customQuotationQuote.form";
import { ControlledUnifiedInput } from "@/components/ui/customs/controlled-unified-input";
import { ControlledCustomTextarea } from "@/components/ui/customs/controlled-custom-textarea";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import { useTranslateMessage } from "@/hooks/useTranslateMessage";
import { Trans, useTranslation } from "react-i18next";

export const InfoReExpeBo = ({ index = 5 }: { index?: number }) => {
  const translateMessage = useTranslateMessage();
  const { t } = useTranslation(["boExpeditionForm", "common"]);
  const methods = useFormContext<ReQuotationBoFormData | ReCustomQuotationFormData>();

  return (
    <div className="flex flex-col gap-2 rounded-lg bg-blue-50 p-4">
      <div className="flex flex-row items-center gap-2">
        <div className="bg-brand600 rounded-full px-3 py-1 text-xl font-bold text-white">
          <p className="text-xl font-bold text-white">{index}</p>
        </div>
        <p className="text-xl font-bold">{t("infoReExpe.title")}</p>
      </div>
      <div className="flex w-full flex-col gap-1">
        <div className="flex w-full flex-row gap-2">
          <ControlledUnifiedInput
            inputType="integer"
            name="overallDiscountPercentage"
            label={t("infoReExpe.overallDiscountLabel")}
            control={methods.control}
            placeholder={t("infoReExpe.overallDiscountPlaceholder")}
            className="w-full"
            wrapperClassName="w-full"
          />
          <ControlledUnifiedInput
            inputType="integer"
            name="transportDiscountPercentage"
            label={t("infoReExpe.transportDiscountLabel")}
            control={methods.control}
            placeholder={t("infoReExpe.transportDiscountPlaceholder")}
            className="w-full"
            wrapperClassName="w-full"
          />
        </div>
        <p className="text-sm text-gray-500">
          <Trans
            t={t}
            i18nKey="infoReExpe.discountHelp"
            components={{ bold: <span className="font-bold" /> }}
          />
        </p>
        <ControlledCustomTextarea
          name="note"
          label={t("infoReExpe.noteLabel")}
          control={methods.control}
          placeholder="..."
          className="w-full"
        />
        <Controller
          name="skipPickup"
          control={methods.control}
          render={({ field, fieldState }) => (
            <div className="flex w-fit flex-col gap-2 rounded-lg border border-gray-300 bg-white p-3">
              <p className="text-sm font-medium">{t("infoReExpe.skipPickupQuestion")}</p>
              <div className="flex flex-row gap-2">
                <Button
                  variant="outline"
                  type="button"
                  onClick={() => field.onChange(false)}
                  className={cn(
                    "rounded-md border px-4 py-1.5 text-sm font-medium transition-colors",
                    field.value === false
                      ? "border-green-600 bg-green-50 text-green-700"
                      : "border-gray-300 bg-white text-gray-600 hover:bg-gray-50",
                  )}
                >
                  {t("common:boolean.yes")}
                </Button>
                <Button
                  type="button"
                  variant="outline"
                  onClick={() => field.onChange(true)}
                  className={cn(
                    "rounded-md border px-4 py-1.5 text-sm font-medium transition-colors",
                    field.value === true
                      ? "border-red-600 bg-red-50 text-red-700"
                      : "border-gray-300 bg-white text-gray-600 hover:bg-gray-50",
                  )}
                >
                  {t("common:boolean.no")}
                </Button>
              </div>
              {fieldState.error && (
                <p className="text-xs text-red-500">{translateMessage(fieldState.error.message)}</p>
              )}
            </div>
          )}
        />
      </div>
    </div>
  );
};
